export default __webpack_public_path__ + "static/media/squares500.9f9b55d3.jpg";